import { Instruction, OpCode } from '../internal.js';
/**
 * Sign Instruction.
 *
 * The given signature and pubkey signs ALL the transaction instructions.
 */
export class SignInstruction extends Instruction {
    sig;
    pubkey;
    constructor(sig, pubkey) {
        super(OpCode.SIGN);
        this.sig = sig;
        this.pubkey = pubkey;
    }
}
/**
 * Sign Args Serializer object - implements the Serializable interface.
 */
export const SignArgsSerializer = {
    read(buf) {
        const sig = buf.readFixedBytes(64);
        const pubkey = buf.readFixedBytes(32);
        return new SignInstruction(sig, pubkey);
    },
    write(buf, instruction) {
        buf.writeFixedBytes(instruction.sig);
        buf.writeFixedBytes(instruction.pubkey);
        return buf;
    }
};
